import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';

import QuizApi from '../QuizApi';

const GENRE_OPTIONS = [
  { value: "pop",       label: "Pop" },
  { value: "rock",      label: "Rock" },
  { value: "hiphop",    label: "Rap/Hip Hop" },
  { value: "dance",     label: "Dance" },
  { value: "rnb",       label: "R&B" },
  { value: "metal",     label: "Metal" },
  { value: "jazz",      label: "Jazz" },
  { value: "classical", label: "Klassisk" },
  { value: "reggae",    label: "Reggae" },
  { value: "soulfunk",  label: "Soul & Funk" },
  { value: "film",      label: "Filmmusik" },
  { value: "kids",      label: "Barn" },
  { value: "folk",      label: "Folkmusik" }
];

const SPECIAL_OPTIONS = [
  { value: "svensk", label: "Svensk musik" },
  { value: "jul",    label: "Julmusik" }
];

export default function MusicQuizGenerateModal({ show, onHide, quizId, onGenerated }) {

  const [theme, setTheme] = useState("pop");
  const [yearFrom, setYearFrom] = useState("");
  const [yearTo, setYearTo] = useState("");
  const [count, setCount] = useState(10);
  const [mode, setMode] = useState("artist");
  const [answerFormat, setAnswerFormat] = useState("choice");
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  async function handleGenerate() {

    if (yearFrom && yearTo && Number(yearFrom) > Number(yearTo)) {
      setErrorMsg("Från-år måste vara mindre än eller lika med till-år.");
      return;
    }

    const countNum = Number(count);
    if (!countNum || countNum < 4 || countNum > 20) {
      setErrorMsg(answerFormat === "choice"
        ? "Antal frågor måste vara mellan 4 och 20 (behövs för att kunna skapa 3 felaktiga svarsalternativ per fråga)."
        : "Antal frågor måste vara mellan 4 och 20.");
      return;
    }

    if (submitting) {
      return;
    }

    setSubmitting(true);
    setErrorMsg("");

    const result = await QuizApi.quizMusicBulkGenerate(quizId, {
      theme,
      yearFrom: yearFrom ? Number(yearFrom) : null,
      yearTo: yearTo ? Number(yearTo) : null,
      count: countNum,
      mode,
      inputMode: answerFormat === "input"
    });

    setSubmitting(false);

    if (result && result.success) {
      onGenerated();
    } else {
      setErrorMsg((result && result.error) || "Kunde inte starta generering. Försök igen.");
    }
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Snabbgenerera musikquiz</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

        <div className="form-group">
          <label htmlFor="musicQuizTheme">Genre</label>
          <select
            id="musicQuizTheme"
            className="form-control"
            value={theme}
            onChange={ev => setTheme(ev.target.value)}>
            <optgroup label="Genre">
              {GENRE_OPTIONS.map(g => <option key={g.value} value={g.value}>{g.label}</option>)}
            </optgroup>
            <optgroup label="Special">
              {SPECIAL_OPTIONS.map(g => <option key={g.value} value={g.value}>{g.label}</option>)}
            </optgroup>
          </select>
        </div>

        <div className="d-flex flex-wrap musicQuizYearRow" style={{ gap: "12px" }}>
          <div className="form-group" style={{ flex: "1 1 140px" }}>
            <label htmlFor="musicQuizYearFrom">Från år (valfritt)</label>
            <input
              type="number"
              id="musicQuizYearFrom"
              className="form-control"
              placeholder="t.ex. 1970"
              value={yearFrom}
              onChange={ev => setYearFrom(ev.target.value)} />
          </div>
          <div className="form-group" style={{ flex: "1 1 140px" }}>
            <label htmlFor="musicQuizYearTo">Till år (valfritt)</label>
            <input
              type="number"
              id="musicQuizYearTo"
              className="form-control"
              placeholder="t.ex. 1979"
              value={yearTo}
              onChange={ev => setYearTo(ev.target.value)} />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="musicQuizCount">Antal frågor</label>
          <input
            type="number"
            id="musicQuizCount"
            className="form-control"
            min="4" max="20"
            value={count}
            onChange={ev => setCount(ev.target.value)} />
        </div>

        <div className="form-group">
          <label>Frågetyp</label>
          <div className="form-check">
            <input
              type="radio"
              id="musicQuizModeArtist"
              name="musicQuizMode"
              className="form-check-input"
              checked={mode === "artist"}
              onChange={() => setMode("artist")} />
            <label className="form-check-label" htmlFor="musicQuizModeArtist">Artist eller grupp?</label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              id="musicQuizModeTitle"
              name="musicQuizMode"
              className="form-check-input"
              checked={mode === "title"}
              onChange={() => setMode("title")} />
            <label className="form-check-label" htmlFor="musicQuizModeTitle">Vilken låt är det?</label>
          </div>
        </div>

        <div className="form-group">
          <label>Svarsformat</label>
          <div className="form-check">
            <input
              type="radio"
              id="musicQuizAnswerFormatChoice"
              name="musicQuizAnswerFormat"
              className="form-check-input"
              checked={answerFormat === "choice"}
              onChange={() => setAnswerFormat("choice")} />
            <label className="form-check-label" htmlFor="musicQuizAnswerFormatChoice">Flervalsalternativ</label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              id="musicQuizAnswerFormatInput"
              name="musicQuizAnswerFormat"
              className="form-check-input"
              checked={answerFormat === "input"}
              onChange={() => setAnswerFormat("input")} />
            <label className="form-check-label" htmlFor="musicQuizAnswerFormatInput">Skriv in svar</label>
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={submitting}>
          Avbryt
        </Button>
        <Button className="btn-quizPrimaryDark" onClick={handleGenerate} disabled={submitting}>
          {submitting ? <Spinner animation="border" size="sm" /> : "Generera"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
